// Datas no fuso do dispositivo (Portugal), no formato AAAA-MM-DD.
// Substitui toISOString().split("T")[0], que devolve a data em UTC e marca
// o dia anterior entre a meia-noite e a 1h (hora de verão).
export const dataISO = (d) => {
  const x = d instanceof Date ? d : new Date(d);
  const p = (n) => String(n).padStart(2, "0");
  return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())}`;
};
export const hojeISO = () => dataISO(new Date());
